<div class="modal fade in" id="add-to-group-dialog" style="display: none;" appDraggable dragTarget="#add-to-group-dialog" dragHandle="#addToGroupDialogHeader">
	<div class="modal-dialog modal-sm">
		<!-- Modal content-->
		<div class="modal-content">
			<div class="modal-header" id="addToGroupDialogHeader">
				<button type="button" class="close" data-dismiss="modal">x</button>
				<h4 class="modal-title">Add To Group</h4>
			</div>
			<div class="modal-body">
				<p>Add the following items  to which group?</p>
				<div id="addGroupDropDown">
					<select style="color: #000000" [(ngModel)]="mSelectedGroup">
						<ng-container *ngIf="mGroups != null">
							<option *ngFor="let group of mGroups" [ngValue]="group">
								{{group.name}}
							</option>
						</ng-container>
					</select>
				</div>
				<div id="addToGroupName">
					<ng-container *ngIf="mObjectNames != null">
						<ng-container *ngFor="let objectName of mObjectNames">
							<div>{{objectName}}</div>
						</ng-container>
					</ng-container>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-default" data-dismiss="modal">CANCEL</button>
				<button type="button" class="btn btn-primary" (click)="confirm()">OK</button>
			</div>
		</div>
	</div>
</div>
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>
